import {useEffect, useMemo} from "react";
import {useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Loading from "../Loading";
import {MODE} from "../Campaign/campaignMode";
import {getEnvName, saveHistory} from "../Utils/CommonUtils";
import {useSelectAbTestByIdQuery} from "../../core/reducers/abtest";
import {SEARCH_TYPES} from "../../core/reducers/typeFilter";
import AbTestForm from "./AbTestForm";
import {abTestFromApi} from "./abTestFormModel";

/** Загружает AB-тест и открывает конструктор в режиме UPDATE / CLONE. */
export default function UpdateAbTestForm({abTestId, mode}) {
    const [searchParams] = useSearchParams();
    const sourceMode = useSelector((state) => state.data.SourceMode);
    const envName = getEnvName('env', sourceMode, searchParams);
    const {error, status, data: abTest, isLoading, isError} = useSelectAbTestByIdQuery({
        env: envName,
        id: abTestId
    }, {skip: !abTestId});

    useEffect(() => {
        if (mode === MODE.UPDATE && status === 'fulfilled') {
            saveHistory(abTest.id, envName, SEARCH_TYPES.AB_TESTS);
        }
    }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

    // раньше объект пересобирался на каждый рендер
    const initial = useMemo(() => abTest ? abTestFromApi(abTest, {mode}) : null, [abTest, mode]);

    return (
        <Loading isLoading={isLoading} isError={isError} error={error}>
            {initial && <AbTestForm
                mode={mode === MODE.CLONE ? MODE.CLONE : MODE.UPDATE}
                title={abTestId}
                abTest={initial}
            />}
        </Loading>
    );
}
